
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BOSell } from '../models/BOSell.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { GlobalConstants } from '../common/global-constants';
import { BOSellDataSended } from '../models/BOSellDataSended.model';
import { BOFilter } from '../models/BOFilter';
import { BODateRangeFilter } from '../models/BODateRangeFilter.model';
import { BOPayTypeSellDetail } from '../models/BOPayTypeSellDetail.model';
import { BOSubServiceDetail } from '../models/BOSubServiceDetail.model';
import { IDataSubServiceAgrouped } from '../interfaces/Igeneral.interface';

@Injectable({
  providedIn: 'root'
})
export class SellService
{
    myAppUrl = GlobalConstants.apiURL;
    //myAppURlLocal= GlobalConstants.apiURlLocal;
    myApiUrl = 'api/sell/';
    dataSell:BOSellDataSended= new BOSellDataSended();
    private areaSubject = new BehaviorSubject<number>(0);

    dataSellBhSubject$= new BehaviorSubject<BOSellDataSended>(this.dataSell);
    area$ = this.areaSubject.asObservable();

    constructor(private http:HttpClient){}



    setDataSellBhSubject(data:BOSellDataSended){
      this.dataSellBhSubject$.next(data);
    }

    getDataSellBhSubject()
    {
      return this.dataSellBhSubject$.asObservable();
    }

    saveSell(sell:BOSell):Observable<BOSell>{
      const httpOptions = {
          headers: new HttpHeaders({'Content-Type': 'application/json'})
        }
        const body=JSON.stringify(sell);
      return this.http.post<BOSell>(this.myAppUrl + this.myApiUrl+'saveSell',body,httpOptions);
    }

    saveUrl(sellId:number, url:string):Observable<number>
    {
      const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body=JSON.stringify(url);
      return this.http.post<number>(this.myAppUrl + this.myApiUrl + 'saveUrl/'+sellId, body, httpOptions);

    }

    getSellByClinicHistoryId(clinicHistoryId:number):Observable<BOSell>
    {
      return this.http.get<BOSell>(this.myAppUrl + this.myApiUrl + 'getSellByClinicHistoryId/'+clinicHistoryId);
    }

    getSell(sellId:number):Observable<BOSell>
    {
      return this.http.get<BOSell>(this.myAppUrl + this.myApiUrl + 'getSell/'+sellId);

    }

    getSells(filter:BOFilter):Observable<BOSell[]>
    {
      const httpOptions = {
          headers: new HttpHeaders({'Content-Type': 'application/json'})
        }
        const body=JSON.stringify(filter);
      return this.http.post<BOSell[]>(this.myAppUrl + this.myApiUrl + 'getAll',body,httpOptions);
    }

    // getSells(filter:BOFilter, areaId:number):Observable<BOSell[]>
    // {
    //   const httpOptions = {
    //       headers: new HttpHeaders({'Content-Type': 'application/json'})
    //     }
    //     const body=JSON.stringify(filter);
    //   return this.http.post<BOSell[]>(this.myAppUrl + this.myApiUrl + 'getAll/'+areaId,body,httpOptions);
    // }

    getAllSellsByClinicHistoryId(clinicHistoryId:number):Observable<BOSell[]>
    {
      return this.http.get<BOSell[]>(this.myAppUrl + this.myApiUrl + 'getAllSellsByClinicHistoryId/'+clinicHistoryId);
    }


///(No. 1)
    getAllSellsByUserId(userId:number):Observable<BOSell[]>
    {
      return this.http.get<BOSell[]>(this.myAppUrl + this.myApiUrl + 'getAllSellsByUserId/'+userId);
    }
///NUEVO REEMPLAZA A (No.1)
    getAllSellsByUserIdString(userId:string):Observable<BOSell[]>
    {
      return this.http.get<BOSell[]>(this.myAppUrl + this.myApiUrl + 'getAllSellsByUserIdString/'+userId);
    }


    getSellByInvoiceTypeAndDates(filter:BODateRangeFilter):Observable<Array<Array<BOSell>>>
    {
      const httpOptions = {
          headers: new HttpHeaders({'Content-Type': 'application/json'})
        }
        const body=JSON.stringify(filter);
      return this.http.post<Array<Array<BOSell>>>(this.myAppUrl + this.myApiUrl + 'getSellByInvoiceTypeAndDates',body,httpOptions);
    }

    getPayTypeByDates(filter:BODateRangeFilter, areaId):Observable<BOPayTypeSellDetail[][]>
    {
      const httpOptions = {
          headers: new HttpHeaders({'Content-Type': 'application/json'})
        }
        const body=JSON.stringify(filter);
        return this.http.post<BOPayTypeSellDetail[][]>(this.myAppUrl + this.myApiUrl + 'getPayTypeByDates/'+areaId,body,httpOptions);
    }

    getPayTypesSellDetailsByIdAndDates(datesFilter:BODateRangeFilter, payTypeId:number):Observable<BOPayTypeSellDetail[][]>{
      const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body= JSON.stringify(datesFilter);
      return this.http.post<BOPayTypeSellDetail[][]>(this.myAppUrl + this.myApiUrl + 'getPayTypesSellDetailsByIdAndDates/'+payTypeId,body,httpOptions);
    }

    postSavedPdf(data: Blob, nameFile:string ): Observable<boolean> {
      const fileName = nameFile.endsWith('.pdf') ? nameFile : `${nameFile}.pdf`;
      const formData = new FormData();
      formData.append('file', data, nameFile); // Asocia el Blob con un nombre

      return this.http.post<boolean>(this.myAppUrl + this.myApiUrl + 'postSavedPdf', formData);
    }

        //NUEVO PTSD=PayTypesSellDetails
    getPTSDByAreaAndDates(datesFilter:BODateRangeFilter, areaId:number, profId:number):Observable<BOPayTypeSellDetail[][]>{
      const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body= JSON.stringify(datesFilter);
      return this.http.post<BOPayTypeSellDetail[][]>(this.myAppUrl + this.myApiUrl + 'getPTSDByAreaAndDates/'+areaId +'/'+profId,body,httpOptions);
    }


//#region Sbsvcss

    getSbsvcsAll(datesFilter:BODateRangeFilter, selectedArea:number):Observable<BOSubServiceDetail[][]>{
      const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body= JSON.stringify(datesFilter);
      return this.http.post<BOSubServiceDetail[][]>(this.myAppUrl + this.myApiUrl + 'getSbsvcsAll/'+selectedArea, body,httpOptions);
    }


    getSbsvcsAgroupedByService(datesFilter:BODateRangeFilter, selectedArea:number):Observable<BOSubServiceDetail[][]>{
      const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body= JSON.stringify(datesFilter);
      return this.http.post<BOSubServiceDetail[][]>(this.myAppUrl + this.myApiUrl + 'getSbsvcsAgroupedByService/'+selectedArea, body,httpOptions);
    }

    getSbsvcsByProfessional(datesFilter:BODateRangeFilter, professionalId:number):Observable<IDataSubServiceAgrouped[]>{
      const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body= JSON.stringify(datesFilter);
      return this.http.post<IDataSubServiceAgrouped[]>(this.myAppUrl + this.myApiUrl + 'getSbsvcsByProfessional/'+professionalId,body,httpOptions);
    }


    getSbsvcsByPatient(datesFilter:BODateRangeFilter, patientId:number):Observable<IDataSubServiceAgrouped[]>{
      const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body= JSON.stringify(datesFilter);
      return this.http.post<IDataSubServiceAgrouped[]>(this.myAppUrl + this.myApiUrl + 'getSbsvcsByPatient/'+patientId,body,httpOptions);
    }

//MODELO 0
    getSbsvcsByPatientIdAndArea(datesFilter:BODateRangeFilter, patientId:number, selectedArea:number):Observable<IDataSubServiceAgrouped[]>{
      const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body= JSON.stringify(datesFilter);
      return this.http.post<IDataSubServiceAgrouped[]>(this.myAppUrl + this.myApiUrl + 'getSbsvcsByPatientIdAndArea/'+patientId+'/'+selectedArea,body,httpOptions);
    }

//REEMPLAZO 0
    getSbsvcsByPatientIdAndAreaString(datesFilter:BODateRangeFilter, patientId:string, selectedArea:number):Observable<IDataSubServiceAgrouped[]>{
      const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body= JSON.stringify(datesFilter);
      return this.http.post<IDataSubServiceAgrouped[]>(this.myAppUrl + this.myApiUrl + 'getSbsvcsByPatientIdAndAreaString/'+patientId+'/'+selectedArea,body,httpOptions);
    }

    getPayTypesByDatesPatientIdAndArea(datesFilter:BODateRangeFilter, patientId:number, selectedArea:number):Observable<BOPayTypeSellDetail[]>{
      const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body= JSON.stringify(datesFilter);
      return this.http.post<BOPayTypeSellDetail[]>(this.myAppUrl + this.myApiUrl + 'getPayTypesByDatesPatientIdAndArea/'+patientId+'/'+selectedArea,body,httpOptions);
    }

    getPayTypesByDatesPatientIdAndAreaString(datesFilter:BODateRangeFilter, patientId:string, selectedArea:number):Observable<BOPayTypeSellDetail[]>{
      const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body= JSON.stringify(datesFilter);
      return this.http.post<BOPayTypeSellDetail[]>(this.myAppUrl + this.myApiUrl + 'getPayTypesByDatesPatientIdAndAreaString/'+patientId+'/'+selectedArea,body,httpOptions);
    }


    getAllPayTypesByDatesAndArea(datesFilter:BODateRangeFilter,  selectedArea:number):Observable<BOPayTypeSellDetail[]>{
      const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body= JSON.stringify(datesFilter);
      return this.http.post<BOPayTypeSellDetail[]>(this.myAppUrl + this.myApiUrl + 'getAllPayTypesByDatesAndArea/'+selectedArea,body,httpOptions);
    }




//#endregion Region Sbsvcs

}
